import classNames from 'classnames';
import React, { useMemo } from 'react';
import { createMockEntitiesArray } from '../../../utils';
import Skeleton from '../../Skeleton/Skeleton';
import styles from './index.module.css';

const SKELETON_COUNT = 6;

export const GameCardsLineItemSkeleton = () => (
  <Skeleton className={styles.card} />
);

const GameCardsLineListSkeleton = ({ className, limit }) => {
  const customLimit = limit ?? SKELETON_COUNT;

  const items = useMemo(
    () => createMockEntitiesArray(customLimit),
    [customLimit]
  );

  return (
    <div className={classNames(styles.wrapper, className)}>
      <div className={styles.header}>
        <Skeleton className={styles.title} />
        <Skeleton className={styles.more} />
      </div>
      <div className={styles.list}>
        {items.map((item) => (
          <GameCardsLineItemSkeleton key={item.id} />
        ))}
      </div>
    </div>
  );
};

export default GameCardsLineListSkeleton;
